import { useApi, Res } from '../../state/api';
import { useTranslation } from '../../i18n/i18n';
import { ProductListing } from '../ProductListing/ProductListing';
import { Loader } from '../Loader/Loader';
import { MetaContainer } from '../../state/meta';
import { generateUUID } from '../utils';
import { useConfig } from '../../config';
import { Loop54EntityRequestBody } from '../../types';

export const SimilarProducts = ({ productId }: { productId: number }): JSX.Element => {
	const t = useTranslation().product;
	const config = useConfig();
	const { searchProfileId, randomizeSearchProfileId } = MetaContainer.useContainer();
	const loop54PostHeaders = {
		'Api-Version': 'V3',
		'User-id': randomizeSearchProfileId ? generateUUID() : searchProfileId,
	};
	const resultsLimit = 12;
	const offset = 0;
	const similarProductsPayload: Loop54EntityRequestBody = {
		resultsOptions: {
			skip: offset,
			take: resultsLimit,
		},
		entity: { type: 'Product', id: productId + '' },
	};

	const { data } = useApi(
		Res.similarProductsLoop54,
		{ limit: resultsLimit, offset, productId },
		config.loop54Api,
		similarProductsPayload,
		loop54PostHeaders,
		'POST'
	);

	if (!data) return <Loader />;
	if (!data.results || data.results.count === 0) return <></>;

	return (
		<>
			<h2>{t.similarProducts}</h2>
			<ProductListing products={data.results.items} />
		</>
	);
};
